import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { User } from "./authSlice";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export declare interface GrouilleurState {
  [index: string]: any;
}
const initialState: GrouilleurState = {};

export const grouilleurSlice = createSlice({
  initialState,
  name: "grouilleur",
  reducers: {
    createGrouilleur: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listGrouilleur: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeGrouilleur: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateGrouilleur: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createGrouilleur,
  listGrouilleur,
  removeGrouilleur,
  updateGrouilleur,
} = grouilleurSlice.actions;

export const createAsyncGrouilleur =
  (data: User, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}utilisateur`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 201) {
        dispatch(listAsyncGrouilleur());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("sign in error", error);
      onError?.();
    }
  };

export const listAsyncGrouilleur =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}grouilleur/admin-all?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      if (res.data.length) {
        dispatch(listGrouilleur(res.data));
      }
    } catch (error) {
      console.log("list grouilleur error", error);
      // onError?.();
    }
  };

export const getAsyncGrouilleur =
  (id:string, callback: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}grouilleur/admin-all/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      callback(res);
     
    } catch (error) {
      console.log("get grouilleur error", error);
      // onError?.();
    }
  };

export const exportAsyncGrouilleur =
  (callback?: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}grouilleur/admin-all/export`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const resBlob = await result.blob();

      callback?.(resBlob);
     
    } catch (error) {
      console.log("export grouilleur error", error);
      // onError?.();
    }
  };

export default grouilleurSlice.reducer as Reducer<GrouilleurState>;
